export default __webpack_public_path__ + "static/media/music-band.f3a3a3a1.png";